import './FilenameState.scss';

import { defineComponent, h, PropType } from 'vue';
import { Background } from '../Colours';
import type { State } from '../state';

import FloatingText from './FloatingText';

export default defineComponent({
    props: {
        /** background colour */
        background: { required: true, type: String as PropType<Background>},

        /** the autosave status */
        status: { required: true, type: String as PropType<State['file_save_status']> },

        /** current file name */
        name: { required: true, type: String },
    },

    computed: {
        text() {
            if (this.name.length === 0)
                return '';
            switch(this.status) {
                case 'saving':
                    return 'Saving...';
                case 'dirty':
                    return this.name.endsWith('.phi')
                        ? `Unsaved: ${this.name}`
                        : `Unsaved: ${this.name}.phi`;
                case 'autosaved':
                    return this.name.endsWith('.phi')
                        ? `Autosaved: ${this.name}`
                        : `Autosaved: ${this.name}.phi`;
                case 'saved':
                    return this.name.endsWith('.phi')
                        ? this.name
                        : this.name + '.phi';

            }
        },
    },

    render() {
        return h('div', {
            id: 'filename-state',
            class: {
                light: this.background === Background.white,
            }
        }, h(FloatingText, {
            variant: this.status === 'dirty' ? 'brand' : '',
        }, () => this.text));
    }
});
